import { useFiltersSyncWithUrl } from "@/shared/hooks/use-dynamic-filters-sync";
import { useControlResultFiltersStore } from "../store/control-result-filters.store";

export function useControlResultFiltersSyncWithUrl<
  O extends Record<string, string>,
  R extends keyof O,
  N extends keyof O,
>({
  urlKeys,
  rangeColumns,
  numericColumns,
}: {
  urlKeys: O;
  rangeColumns: R[];
  numericColumns: N[];
}) {
  const filtersStore = useControlResultFiltersStore();

  return useFiltersSyncWithUrl<O, R, N>({
    filtersStore,
    urlKeys,
    rangeColumns: rangeColumns,
    numericColumns,
  });
}
